import { Errors } from '../enums/errors';
/**
 * Represents a storage resolution error.
 */
export class FileError extends Error {
    /**
     * Represents a storage resolution error.
     *
     * @param code - The error code.
     * @param message - The error message.
     */
    constructor(code = Errors.STORAGE_ERROR, message = 'File Error') {
        super(message);
        /**
         * True if the error breaks the ability to play tracks ie. if the user has
         * been play capped.
         */
        this.canPlayNext = true;
        /**
         * Additional debugging information for the error.
         */
        this.debug = {};
        this.code = code;
        this.message = message;
        this.name = 'FileError';
    }
}
//# sourceMappingURL=file.js.map